import { useState } from "react";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { sendUserDT } from "../axios/user";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

const useGenerateDeviceToken = () => {
  const [deviceToken, setDeviceToken] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

  const getAndSetToken = async () => {
    try {
      const messaging = getMessaging(firebaseApp);
      const serviceWorkerRegistration = await navigator.serviceWorker.register(
        "/sw.js",
        { scope: "/" },
      );
      await navigator.serviceWorker.ready;
      const token = await getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration,
      });
      if (token) {
        setDeviceToken(token);
        return token;
      } else {
        throw new Error("Failed to retrieve FCM token");
      }
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Unknown error");
      }
      return null;
    }
  };

  const requestAndSendToken = async () => {
    setLoading(true);
    try {
      if ("safari" in window && (window as any).safari.pushNotification) {
        const safariPush = (window as any).safari.pushNotification as {
          permission: (pushId: string) => {
            permission: "default" | "granted" | "denied";
            deviceToken?: string;
          };
          requestPermission: (
            packageURL: string,
            pushId: string,
            payload: any,
            callback: (permissionData: {
              permission: "default" | "granted" | "denied";
              deviceToken?: string;
            }) => void,
          ) => void;
        };

        const pushId = "app.coachmate.push";
        const packageURL = "https://app.coachmate.ai";

        const permissionData = safariPush.permission(pushId);
        if (permissionData.permission === "default") {
          safariPush.requestPermission(
            packageURL,
            pushId,
            {},
            (permissionResult) => {
              if (permissionResult.permission === "granted") {
              } else {
                console.warn("Сповіщення відхилені");
              }
            },
          );
        }
      } else {
        const permission = Notification.permission;
        if (permission === "default") {
          const permissionResult = await Notification.requestPermission();
          if (permissionResult === "granted") {
            const token = await getAndSetToken();
            if (token) {
              await sendUserDT(token);
            }
          } else {
            console.warn("User did not grant notification permissions.");
          }
        } else if (permission === "granted") {
          const token = await getAndSetToken();
          if (token) {
            await sendUserDT(token);
          }
        } else {
          console.warn("User denied notification permissions.");
        }
      }
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Unknown error");
      }
    } finally {
      setLoading(false);
    }
  };

  return { deviceToken, error, loading, requestAndSendToken };
};

export default useGenerateDeviceToken;
